var React = require('react');

function EyeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"currentColor","d":"M11 5C5.91 5 2.212 9.174 1 11.26 2.364 13 5.09 17 11 17c5.454 0 8.636-4 10-5.74C19.788 9.175 16.09 5 11 5z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M13 8a1 1 0 100-2 1 1 0 000 2zM15.5 11a.5.5 0 100 1 .5.5 0 000-1zm-1.5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z","key":1}),React.createElement("path",{"stroke":"currentColor","d":"M15 12.142c-.514 1.932-2.3 3.358-4.426 3.358C8.048 15.5 6 13.485 6 11s2.048-4.5 4.574-4.5c.833 0 1.614.22 2.287.602","key":2})]);
}

EyeInline.defaultProps = {"fill":"none","viewBox":"0 0 22 22"};

module.exports = EyeInline;

EyeInline.default = EyeInline;
